module.exports = __webpack_public_path__ + "img/phone_k71.a750c424.png";